// extracted by mini-css-extract-plugin
export default {"menu":"aside_menu_menu__VFS-p","menuOpened":"aside_menu_menuOpened__DHVTu"};